import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import DefaultPage from '../components/layout/DefaultPage';
import Welcome from '../components/layout/Welcome';
import BettingBuddy from '../containers/bettingBuddy/BettingBuddyPage';
import DefaultView from '../containers/layout/DefaultView';
import LiveScores from '../containers/liveScores/LiveScores';
import LoginConsents from '../containers/loginConsents';
import LinkSuccess from '../containers/omniLink/LinkSuccess';
import LoginSuccess from '../containers/omniLink/LoginSuccess';
import RegistrationSuccess from '../containers/omniLink/RegistrationSuccess';
import OpenBets from '../containers/openBets/Page';
import Policies from '../containers/policies/Page';
import Activate from '../containers/registration/Activate';
import EnterLBO from '../containers/registration/EnterShopId';
import ChangePhoneNumber from '../containers/settings/ChangePhoneNumber';
import LostCard from '../containers/settings/LostCard';
import MarketingPreferences from '../containers/settings/MarketingPreferences';
import SetPIN from '../containers/settings/SetPIN';
import Settings from '../containers/settings/Settings';
import SettledBets from '../containers/settledBets/Page';
import Transfer from '../containers/transfer/Transfer';
import AddBetslip from '../containers/views/AddBetslip';
import Home from '../containers/views/Home';
import Landing from '../containers/views/Landing';
import Login from '../containers/views/Login';
import NotFound from '../containers/views/NotFound';
import ResponsibleGambling from '../containers/views/ResponsibleGambling';
import Support from '../containers/views/Support';
import withAuth from '../containers/withAuth';
import Withdraw from '../containers/withdraw';
import { isAuthenticated, isAuthorized } from '../modules/user/selectors';
import * as paths from './paths';
import LinkAccount from '../containers/views/LinkAccount';
import Register from '../containers/views/Register';

const wrapComponent = (Component, Wrapper = DefaultView) => (() => (
  <Wrapper>
    <Component />
  </Wrapper>
));

const wrapInDefaultPage = Component => (() => (
  <DefaultView>
    <DefaultPage>
      <Component />
    </DefaultPage>
  </DefaultView>
));

export default (
  <Switch>
    <Redirect exact from={paths.DEFAULT} to={paths.LANDING} />
    <Route path={paths.LANDING} component={Landing} />
    <Redirect exact from={paths.REWARDS} to={paths.HOME} />
    <Route path={paths.HOME} component={wrapInDefaultPage(withAuth(isAuthorized)(Home))} />
    <Route
      path={paths.WHO_REGISTER_SUCCESS}
      component={withAuth(isAuthenticated)(RegistrationSuccess)}
    />
    <Route path={paths.WHO_LOGIN_SUCCESS} component={withAuth(isAuthenticated)(LoginSuccess)} />
    <Route path={paths.LOGIN} component={wrapComponent(Login, Welcome)} />
    <Route
      path={paths.LOGIN_CONSENTS}
      component={wrapComponent(withAuth(isAuthenticated)(LoginConsents), Welcome)}
    />
    <Route
      path={paths.LINK_SUCCESS}
      component={wrapInDefaultPage(withAuth(isAuthenticated)(LinkSuccess))}
    />
    <Route
      path={paths.OMNI_SET_PIN}
      component={wrapInDefaultPage(withAuth(isAuthenticated)(SetPIN))}
    />
    <Route
      path={paths.OMNI_WITHDRAW}
      component={wrapInDefaultPage(withAuth(isAuthenticated)(Withdraw))}
    />
    <Route
      path={paths.OMNI_TRANSFER}
      component={wrapInDefaultPage(withAuth(isAuthenticated)(Transfer))}
    />
    <Route path={paths.OPEN_BETS} component={wrapInDefaultPage(withAuth(isAuthorized)(OpenBets))} />
    <Route
      path={paths.SETTLED_BETS}
      component={wrapInDefaultPage(withAuth(isAuthorized)(SettledBets))}
    />
    <Route
      path={paths.SETTINGS}
      component={wrapInDefaultPage(withAuth(isAuthenticated)(Settings))}
    />
    <Route
      path={paths.CHANGE_NUMBER}
      component={wrapInDefaultPage(withAuth(isAuthenticated)(ChangePhoneNumber))}
    />
    <Route
      path={paths.MARKETING_PREFERENCES}
      component={wrapInDefaultPage(withAuth(isAuthenticated)(MarketingPreferences))}
    />
    <Route
      path={paths.LOST_CARD}
      component={wrapInDefaultPage(withAuth(isAuthenticated)(LostCard))}
    />
    <Route
      path={paths.ADD_BETSLIP}
      component={wrapInDefaultPage(withAuth(isAuthorized)(AddBetslip))}
    />
    <Route path={paths.SUPPORT} component={wrapInDefaultPage(Support)} />
    <Route path={paths.RESPONSIBLE_GAMBLING} component={wrapInDefaultPage(ResponsibleGambling)} />
    <Route path={paths.NOT_FOUND} component={wrapInDefaultPage(NotFound)} />
    <Route path={paths.TERMS} component={wrapInDefaultPage(Policies)} />
    <Route path={paths.COOKIE} component={wrapInDefaultPage(Policies)} />
    <Route path={paths.LINK_ACCOUNT} component={wrapInDefaultPage(LinkAccount)} />
    <Route path={paths.REGISTER} component={wrapInDefaultPage(Register)} />

    <Route path={paths.ENTER_SHOP_ID} component={wrapComponent(EnterLBO, Welcome)} />
    <Route path={paths.ACTIVATE} component={Activate} />
    <Route
      path={paths.BETTING_BUDDY}
      component={wrapComponent(withAuth(isAuthorized)(BettingBuddy))}
    />
    <Redirect from={paths.NEW_SLIP} to={paths.BETTING_BUDDY} />
    <Route
      path={paths.SAVED_SLIPS}
      component={wrapComponent(withAuth(isAuthenticated)(BettingBuddy))}
    />
    <Route
      path={paths.LIVE_SCORES}
      component={wrapInDefaultPage(withAuth(isAuthorized)(LiveScores))}
    />
    <Redirect from={paths.PRIVACY} to={paths.COOKIE} />
    <Redirect from="*" to={paths.NOT_FOUND} />
  </Switch>
);
